module.exports = __webpack_public_path__ + "img/ax.ee747508.svg";